import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import { defineComponent as _defineComponent } from 'vue';
import { IMPACT_STRATEGY_CONCEPT_ID, IMPACT_CARRY_CONCEPT_ID } from '~/constants/concepts';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    impactGoal: null,
    impact: null
  },
  setup: function setup(__props) {
    var props = __props;

    /**Page used purely for routing to impact sub directories. */

    var route = useRoute();
    var router = useRouter();
    var conceptId = computed(function () {
      var _props$impact;
      return (_props$impact = props.impact) === null || _props$impact === void 0 ? void 0 : _props$impact.conceptId;
    });
    var fullPath = computed(function () {
      return route.fullPath;
    });
    watch([fullPath, conceptId], function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        path = _ref2[0],
        concept = _ref2[1];
      if (!concept) return;
      var redirectPath = '/define';
      if (concept === IMPACT_STRATEGY_CONCEPT_ID) {
        redirectPath = '/impactStrategy';
      } else if (concept === IMPACT_CARRY_CONCEPT_ID) {
        redirectPath = '/impactCarry';
      }
      var lastSegment = (path.split('/').pop() || '').trim();
      var isParentOnly = /^\d+$/.test(lastSegment);
      if (!isParentOnly) return;
      router.replace(path + redirectPath);
    }, {
      immediate: true
    });
    return {
      __sfc: true,
      props: props,
      route: route,
      router: router,
      conceptId: conceptId,
      fullPath: fullPath
    };
  }
});